import { useMemo } from "react";

import { EditGLDAdditionTask, GLDAdditionTask } from "@nens/brostar/uploadapi-client";

import { getApi } from "@/api/api-configuration";
import { getFormObjectValues, initializeFormEditingState } from "@/helpers/helpers";
import { useAfterFormSubmit } from "@/hooks/use-after-form-submit";
import { BrostarForm, useBrostarFormDataStorage } from "@/libs/brostar-form";
import { GldAdditionFormProps } from "@/types/form-types";

import { useGldUiSchema } from "../../schema/gld-ui-schema";

import { getGldAdditionSchema } from "./schema/gld-addition-schema";

export function GldAdditionForm(props: GldAdditionFormProps) {
  const api = getApi();
  const afterSubmit = useAfterFormSubmit();
  const { type, oldUploadTask, task } = getFormObjectValues(props);

  const { isEditing, getIsEditing } = initializeFormEditingState(props);

  const { formData, handleChange } = useBrostarFormDataStorage<
    GLDAdditionTask | EditGLDAdditionTask
  >({ key: "gldAddition", task });
  const uiSchema = useGldUiSchema(formData?.metadata.qualityRegime);
  const schema = useMemo(() => getGldAdditionSchema({ type, isEditing }), [type, isEditing]);

  const onSubmit = async () => {
    if (!formData) return;
    if (getIsEditing(formData)) {
      await api.editGldAddition(formData as EditGLDAdditionTask);
    } else {
      await api.createGldAddition(formData);
    }
    if (oldUploadTask?.uuid) api.apiUploadtasksDelete({ uuid: oldUploadTask.uuid });
    await afterSubmit();
  };

  return (
    <BrostarForm
      schema={schema}
      uiSchema={uiSchema}
      formData={formData}
      onChange={handleChange}
      onSubmit={onSubmit}
      uploadTask={oldUploadTask}
    />
  );
}
